import React from 'react'

function TenderTextQSTSeat() {
  return (
    <embed src="\pdfs\EAT1.6.2_Q-ST_Seat_displacement_outlet_kr.pdf" width="100%" height="2100px" />
  )
}

export default TenderTextQSTSeat